import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Shell } from './components/layout/Shell';
import Home from './components/home/Home';
import ReadSecret from './components/readSecret/ReadSecret';
import DisplaySecretLink from './components/displaySecretLink/DisplaySecretLink';
import Terms from './components/legal/Terms';
import Privacy from './components/legal/Privacy';
import SubProcessors from './components/legal/SubProcessors';
import Security from './components/legal/Security';
import SlackInstalled from './components/slackInstalled/SlackInstalled';
import SlackLanding from './components/slack/SlackLanding';
import Support from './components/support/Support';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell />}>
          <Route path="/" element={<Home />} />
          <Route path="/show/:id" element={<DisplaySecretLink />} />
          <Route path="/s/:id" element={<ReadSecret />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/sub-processors" element={<SubProcessors />} />
          <Route path="/security" element={<Security />} />
          <Route path="/support" element={<Support />} />
          <Route path="/slack" element={<SlackLanding />} />
          <Route path="/slack-installed" element={<SlackInstalled />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
